import { ElevatorFault } from "../flatbuffers/generated/fault/elevator-fault";
import { EscalatorFault } from "../flatbuffers/generated/fault/escalator-fault";
import { FaultContent } from "../flatbuffers/generated/fault/fault-content";

export function getFaultEnumName(
  faultContent: FaultContent,
  code: ElevatorFault | EscalatorFault
): string {
  if (faultContent === FaultContent.ElevatorFaultMessage) {
    return ElevatorFault[code] ?? `Unknown_${code}`;
  }
  if (faultContent === FaultContent.EscalatorFaultMessage) {
    return EscalatorFault[code] ?? `Unknown_${code}`;
  }
  return `Unknown_${code}`;
}

export default function getFaultDisplayName(
  faultContent: FaultContent,
  code: ElevatorFault | EscalatorFault
): string {
  const enumName = getFaultEnumName(faultContent, code);
  if (enumName.startsWith("Unknown")) return enumName;
  return enumName.replace(/([A-Z])/g, " $1").trim();
}
